import type { TOC } from '@ember/component/template-only';
import { on } from '@ember/modifier';
import { PrismIcon } from '@mylighthouse/prism-ember';

interface GeneralButtonsButtonSelectableSignature {
  Args: {
    iconName: unknown;
    iconSize: unknown;
    isDisabled?: boolean;
    isSelected?: boolean;
    onClick: unknown;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLButtonElement;
}

const GeneralButtonsButtonSelectable = <template>
  {{! @glint-nocheck: not typesafe yet }}
  <button
    class="button-selectable flex flex-row items-center justify-center gap-100
      {{if @isSelected 'selected'}}"
    disabled={{@isDisabled}}
    type="button"
    {{on "click" @onClick}}
    ...attributes
  >
    {{#if @iconName}}
      <PrismIcon @color="inherit" @name={{@iconName}} @size={{@iconSize}} />
    {{/if}}

    {{yield}}
  </button>
</template> satisfies TOC<GeneralButtonsButtonSelectableSignature>;

export default GeneralButtonsButtonSelectable;
